var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsyImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#psyImage_svg__clip0_617_10759)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.309 125.765h-17.957v146.147h17.957V125.765z",
    fill: "#C3DCF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.572 107.513H-2v28.965h299.572v-28.965z",
    fill: "#C3DCF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.938 85.376h-45.72v26.07h45.72v-26.07z",
    fill: "#CCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.906.96H57.228a2.163 2.163 0 00-2.163 2.164v88.78c0 1.195.968 2.164 2.163 2.164h145.678a2.164 2.164 0 002.164-2.163V3.124A2.164 2.164 0 00202.906.96z",
    fill: "#CCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.848 4.993H61.096a1.994 1.994 0 00-1.994 1.994v81.258c0 1.101.893 1.994 1.994 1.994h135.752a1.994 1.994 0 001.994-1.994V6.987a1.994 1.994 0 00-1.994-1.994z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.254 109.169h52.894a5.385 5.385 0 015.381 5.381H97.895v-.022a5.361 5.361 0 015.359-5.359z",
    fill: "#CCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.218 109.169h45.72M95.822 94.067h59.492M78.552 95.62a1.655 1.655 0 100-3.311 1.655 1.655 0 000 3.31zM84.76 95.62a1.655 1.655 0 100-3.311 1.655 1.655 0 000 3.31z",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.944 4.993H196.62c1.229 0 2.223.994 2.223 2.224v3.201H59.311V6.627c0-.902.732-1.634 1.633-1.634z",
    fill: "#DEEEFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.848 90.24H61.096a1.995 1.995 0 01-1.994-1.995V6.993c0-1.104.896-1.994 1.994-1.994h135.752M198.841 18.72v53.572",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.505 15.208H68.138a2.142 2.142 0 00-2.141 2.141v64.716c0 1.183.958 2.142 2.141 2.142h122.367a2.142 2.142 0 002.142-2.142V17.35a2.142 2.142 0 00-2.142-2.142z",
    fill: "#DEEEFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "psyImage_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 15,
    width: 128,
    height: 70
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.217 15.209H72.427a6.43 6.43 0 00-6.43 6.43v56.138a6.43 6.43 0 006.43 6.43h113.79a6.43 6.43 0 006.43-6.43V21.64a6.43 6.43 0 00-6.43-6.43z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#psyImage_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.143 37.356c0 9.647 7.184 20.573 16.831 20.573 9.648 0 18.11-10.926 18.11-20.573 0-9.648-7.823-17.471-17.471-17.471-9.647 0-17.47 7.823-17.47 17.47z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.932 54.783v14.27l-4.458 9.112-7.534-1.186-4.457-11.598V48.735l-.268-14.258 13.647 3.654",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.932 54.783v14.27l-4.458 9.112-7.534-1.186-4.457-11.598V48.735l-.268-14.258 13.647 3.654",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.002 67.833l10.948 6.714a29.028 29.028 0 0112.674 16.543l8.299 28.156H76.177l7.157-28.828A21.793 21.793 0 0194.39 76.356l18.738-9.785 26.862 1.262h.011z",
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.914 22.933s14.275 1.873 11.674 17.935c-.89-2.896-4.092-5.425-4.092-5.425s1.787 5.594-5.424 8.817c-6.545-2.65-9.593-12.357-9.593-12.357l7.435-8.965v-.005zM122.751 48.107l-3.939 4.556-2.278-3.48.328-1.863 5.889.787z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 55.197c3.119 3.082 6.424 4.158 9.282 4.327 4.206.257 7.735-3.168 7.724-7.386l-.054-24.015-9.921-2.552-11.363 1.95-5.513 6.955-1.354 5.255 1.693 5.174",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 55.197c3.119 3.082 6.424 4.158 9.282 4.327 4.206.257 7.735-3.168 7.724-7.386l-.054-24.015-9.921-2.552-11.363 1.95-5.513 6.955-1.354 5.255 1.693 5.174",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.869 26.937S140.92 42 122.75 39.874c-11.877 4.37-5.89-7.064-5.89-7.064l3.551-5.446 7.829-3.065 10.21-1.36 7.414 3.998h.005z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.507 37.679s-3.169-3-4.78 0c-1.612 2.999 1.152 9.642 1.152 9.642l-2.436 1.846M137.232 37.46s-3.321-2.295-8.757.873M145.868 40.95s-2.305-2.261-4.054 0M136.308 41.536s-1.874-2.393-5.321.371M141.223 52.122s-2.726 1.682-5.528-.798",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.945 64.043l-7.156 2.791-10.571-4.414-5.075 4.152 12.149 12.456 1.284-4.846s4.037.989 5.911-1.29l3.185 4.153 4.332-9.206-4.064-3.791.005-.005z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.942 64.043l-7.134 4.332-10.593-5.955M135.668 77.044l-6.719-7.845-3.66 9.828",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M132.66 46.495c2.803 0 5.075-2.511 5.075-5.61s-2.272-5.61-5.075-5.61c-2.803 0-5.075 2.511-5.075 5.61s2.272 5.61 5.075 5.61zM144.833 45.873c1.907 0 3.453-2.512 3.453-5.611 0-3.099-1.546-5.61-3.453-5.61-1.907 0-3.453 2.511-3.453 5.61s1.546 5.61 3.453 5.61z",
    fill: "#9EE1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.857 46.56c2.803 0 5.076-2.512 5.076-5.61 0-3.1-2.273-5.611-5.076-5.611-2.803 0-5.075 2.512-5.075 5.61 0 3.1 2.272 5.611 5.075 5.611zM145.026 45.938c1.907 0 3.453-2.512 3.453-5.61 0-3.1-1.546-5.611-3.453-5.611-1.906 0-3.452 2.512-3.452 5.61 0 3.099 1.546 5.61 3.452 5.61zM137.931 40.95h3.999M127.523 40.327h-2.425",
    stroke: "#00B5A6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.698 41.627c-1.426-2.84-4.393-4.233-6.622-3.108-2.229 1.12-2.884 4.332-1.453 7.168 1.426 2.84 4.392 4.233 6.621 3.108",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.698 41.627c-1.426-2.84-4.393-4.233-6.622-3.108-2.229 1.12-2.884 4.332-1.453 7.168 1.426 2.84 4.392 4.233 6.621 3.108",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.112 44.244s-1.268-3.015-4.6-1.994l4.6 1.994z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.112 44.244s-1.268-3.015-4.6-1.994",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.754 46.451s-3.12-1.36-1.475-4.386l1.475 4.386z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.754 46.451s-3.12-1.36-1.475-4.386M116.683 63.677l-3.54 2.895M140.003 67.834l-2.611-2.437",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.835 18.29h-18.629c-1.14 0-2.065.924-2.065 2.064v11.992c0 1.14.925 2.065 2.065 2.065h18.629a2.065 2.065 0 002.065-2.066v-11.99c0-1.141-.924-2.066-2.065-2.066z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.606 132.681H55.068M286.306 132.681H143.453M227.679 136.483h19.257",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.17 71.09H252.475c-13.259 0-24.661 9.397-27.185 22.404l-13.433 69.217a2.287 2.287 0 00-.033.547l3.01 50.681 115.025-4.229s32.986-92.134 32.986-92.981V77.826l-9.664-6.741-.011.005z",
    fill: "#008AE9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.4 153.086l72.271-.038c9.369 0 16.963 7.583 16.963 16.946v34.652h-76.013l-13.226-51.56h.005z",
    fill: "#008AE9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.399 153.086l11.298 4.234a24.876 24.876 0 0116.137 22.737l.476 21.869h83.218l.274-25.278c.136-12.308 9.795-22.404 22.092-23.092l9.315-.519v53.964c0 13.286-10.773 24.054-24.065 24.054h-94.675c-13.291 0-24.065-10.768-24.065-24.054v-53.964",
    fill: "#34A3FA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.67 153.048c9.369 0 16.963 7.588 16.963 16.952v30.418",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M295.348 62.426c8.813 0 15.958-7.145 15.958-15.958s-7.145-15.957-15.958-15.957-15.957 7.144-15.957 15.957 7.144 15.958 15.957 15.958z",
    fill: "#333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M252.668 15.362s-13.707 14.33-2.688 41.262c-.634-12.33 7.069-24.403 7.069-24.403l10.735-5.212 23.584 27.414s20.115-29.075-5.802-45.633c-16.957-10.833-32.898 6.572-32.898 6.572z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M298.741 29.518s.399 10.593-5.14 21.098",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M271.349 53.79s4.819 14.411-2.059 24.381c8.899 8.648 19.011-5.102 19.011-5.102l6.397 2.322s-8.129-15.772-.557-38.433",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M271.349 53.79s4.819 14.411-2.059 24.381c8.899 8.648 19.011-5.102 19.011-5.102l6.397 2.322s-8.129-15.772-.557-38.433",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M285.057 55.406s-5.468 10.177-15.187 9.45c-15.493-1.152-16.264-40.546-16.264-40.546l6.9-7.064 9.959 2.677 13.232 3.726 11.166 7.593",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.057 55.406s-5.468 10.177-15.187 9.45c-15.493-1.152-16.264-40.546-16.264-40.546l6.9-7.064 9.959 2.677 13.232 3.726 11.166 7.593",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M255.06 39.502s1.721-3.857 5.179-2.447c5.922 2.415 1.781 14.373 1.781 14.373l4.239 1.563M265.163 36.182s5.07-2.59 9.069.557",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M258.518 46.907c.641-.183.946-1.086.68-2.017-.266-.931-1.001-1.538-1.643-1.355-.641.183-.945 1.086-.679 2.018.266.93 1.001 1.537 1.642 1.354zM269.511 44.766c.641-.183.946-1.087.68-2.018-.266-.931-1.001-1.538-1.642-1.355-.642.183-.946 1.087-.68 2.018.266.931 1.001 1.538 1.642 1.355zM251.626 24.327S265.081 41.1 284.53 39.132c12.783-3.447 13.045-5.796 13.045-5.796l-1.409-6.506-15.471-9.594-12.243-1.655-7.807 1.207-7.55 2.721-1.48 4.818h.011z",
    fill: "#333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M281.322 40.087c1.098-5.087 4.824-8.6 8.325-7.846 3.502.754 5.453 5.49 4.355 10.577-1.099 5.086-4.824 8.599-8.326 7.845",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M281.322 40.087c1.098-5.087 4.824-8.6 8.325-7.846 3.502.754 5.453 5.49 4.355 10.577-1.099 5.086-4.824 8.599-8.326 7.845",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M285.203 43.396s1.355-6.97 6.244-6.233l-6.244 6.233z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M285.203 43.396s1.355-6.97 6.244-6.233",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M288.756 45.654s3.306-4.305.672-8.178l-.672 8.178z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M288.756 45.654s3.306-4.305.672-8.178M267.169 43.093s.59-4.518 6.911-.71l1.786-1.011M261.631 44.306s-4.316-3.17-5.48.846l-1.344-.306",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M269.291 67.61l25.015-2.792 1.869 8.02 6.976 3.24a36.028 36.028 0 0120.65 36.63l-5.851 53.133-38.558-1.322-53.898-11.483 16.826-54.281a38.717 38.717 0 0120.508-21.006l6.463-2.797V67.61z",
    fill: "#00B5A6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M250.824 158.686l-5.386 11.674-69.824 6.578a33.012 33.012 0 00-27.681 20.929l-37.089 95.598 125.831.601 76.92-83.749 1.983-55.505-64.748 3.879-.006-.005z",
    fill: "#333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M250.824 158.685l1.273-15.761 57.34 2.114 10.626 16.908-69.239-3.261z",
    fill: "#00B5A6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M245.687 186.967l-54.795 5.162c-12.892 1.213-23.502 10.675-26.178 23.349L152.93 271.3",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.489 161.367c2.246 2.273 6.916-2.19 11.495-3.081 4.807-.934 8.32-.251 10.68.727-5.939.519-10.429 2.715-11.5 3.611-.432.36-1.633 1.371-.666 2.562.497.612 1.447.787 2.283.568.836-.224 1.568-.704 2.36-1.038 2.737-1.158 6.916.257 11.762-1.721 3.578-1.458 6.523-5.326 6.523-5.326l13.002.748-1.349-11.505-13.374.383s-5.78-2.595-14.603-2.022c-5.769.377-12.805 1.41-13.581 6.523-3.529 2.377-2.305 4.622-2.305 4.622-1.972 1.682-1.426 4.234-.727 4.944v.005z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M150.847 148.235s-6.944-.574-11.325 3.567l11.325-3.567z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.847 148.235s-6.944-.574-11.325 3.567",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M137.216 156.423s3.982-5.327 13.505-5.076l-13.505 5.076z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M137.216 156.423s3.982-5.327 13.505-5.076",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M149.855 154.571s-9.97-.263-13.362 6.79l13.362-6.79z",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M149.855 154.571s-9.97-.263-13.362 6.79",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M229.634 136.8l-59.099 8.397v16.165l64.355 2.748a20.599 20.599 0 0019.197-11.155l.972-1.885-25.425-14.275v.005z",
    fill: "#00B5A6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M283.207 153.036h56.865s21.912-55.74 15.99-73.489c-2.289-6.85-10.997-8.451-10.997-8.451h11.981c9.227 0 16.252 8.276 14.75 17.372l-9.478 57.401a151.918 151.918 0 00-2.027 24.742v22.442c0 20.989-17.029 38.012-38.034 38.012h-63.12l24.064-78.018.006-.011z",
    fill: "#008AE9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M251.524 201.926l.273-25.278c.136-12.308 9.795-22.404 22.092-23.092l9.315-.519v53.964c0 13.286-10.773 24.054-24.065 24.054h-19.202l11.587-29.129z",
    fill: "#34A3FA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M255.646 103.913l.748 2.753s-8.287 11.036-4.851 24.584c-.328 11.893-.721 27.021-.721 27.021M208.356 139.826l23.087-3.026M275.598 153.037c-13.089 0-23.699 10.609-23.699 23.699v25.196M345.92 71.938c27.91 5.07-5.846 81.099-5.846 81.099h-51.456M296.174 123.995l-2.573 29.053M269.29 74.952s7.937 6.589 21.158.41M265.163 57.434s2.857 1.819 6.96-2.961M226.488 18.06c-.23-.081-.175-.42.071-.42a9.465 9.465 0 008.986-6.392c.082-.23.421-.175.421.071a9.466 9.466 0 006.392 8.987c.229.082.175.42-.071.42a9.466 9.466 0 00-8.987 6.393c-.082.229-.421.174-.421-.072a9.464 9.464 0 00-6.391-8.986zM236.189 7.304c-.136-.05-.104-.251.044-.251a5.673 5.673 0 005.392-3.836c.049-.136.251-.103.251.044a5.672 5.672 0 003.835 5.392c.137.05.104.251-.043.251a5.671 5.671 0 00-5.392 3.836c-.05.136-.252.103-.252-.044a5.672 5.672 0 00-3.835-5.392z",
    stroke: "#333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "psyImage_svg__clip0_617_10759"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .519)",
    d: "M0 0h374v231H0z"
  })))));
}
export default __webpack_public_path__ + "static/psyImage.c735bd4a.svg";
export { SvgPsyImage as ReactComponent };